import api from './api';
import { toast } from 'react-toastify';

/**
 * รหัสส่วนลด 3 แบบใช้ช่องกรอกเดียวกัน แยกกันด้วยคำนำหน้า
 *   ONCE...  ส่วนลดของที่พัก (discount)
 *   VC-...   voucher เข้าพักฟรี
 *   อื่น ๆ    คูปองส่วนลด (coupon item)
 */
export const promoKind = (code = '') => {
  if (code.startsWith('ONCE')) return 'discount';
  if (code.startsWith('VC-')) return 'voucher';
  return 'coupon';
};

const CHECK_ENDPOINT = {
  discount: (code) => `discount/check/${code}`,
  voucher: (code) => `vouchers/check/${code}`,
  coupon: (code) => `coupons/items/${code}`,
};

const RESULT_KEY = { discount: 'discount', voucher: 'voucher', coupon: 'coupon' };

/**
 * ตรวจรหัสกับเซิร์ฟเวอร์ตามเงื่อนไขการจอง (วันเข้าพัก ห้อง จำนวนคืน)
 * ผ่านแล้วเรียก onValid(ข้อมูลส่วนลด) -- ไม่ผ่านจะเตือนด้วยข้อความจากเซิร์ฟเวอร์เอง
 * (silent: ไม่เตือน ให้ผู้เรียกตัดสินเอง -- ใช้ตอนไล่ลองหลายห้องในตะกร้า)
 *
 * ใช้ทั้งตอนลูกค้ากด "ใช้ส่วนลด" และตอนใส่รหัสให้อัตโนมัติจากหน้า voucher/คูปอง
 * ให้ผ่านการตรวจชุดเดียวกันเสมอ
 */
export const checkPromoCode = (code, params, onValid, onInvalid = () => { }, { silent = false } = {}) => {
  const kind = promoKind(code);

  api.request(CHECK_ENDPOINT[kind](encodeURIComponent(code)), (data, suc) => {
    if (!suc) {
      onInvalid();
      return;
    }

    if (data.error) {
      if (!silent) toast.warn(data.message);
      onInvalid(data.message);
      return;
    }

    onValid(data[RESULT_KEY[kind]]);
  }, params);
};

/* ── รหัสที่รอใช้ ─────────────────────────────────────────────────────────
 * ลูกค้าสแกน QR แล้วกด "จองเลย" ที่หน้ารายละเอียด voucher/คูปอง -> เก็บรหัสไว้ตรงนี้
 * แล้วหน้าจอง (modal / ตะกร้า) จะหยิบไปใส่ในช่องและตรวจให้เอง
 *
 * ผูกกับที่พัก -- รหัสของที่พักหนึ่งต้องไม่ถูกเอาไปลองกับอีกที่
 * อยู่ได้ 24 ชม. เพราะลูกค้าอาจเปิดดูวันนี้แต่กลับมาจองพรุ่งนี้
 */
const PENDING_KEY = 'pending_promo_code';
const PENDING_TTL = 1000 * 60 * 60 * 24;
export const PENDING_PROMO_EVENT = 'pending-promo-change';

const notify = () => {
  try { window.dispatchEvent(new Event(PENDING_PROMO_EVENT)); } catch (e) { /* ไม่เป็นไร */ }
};

export const setPendingPromo = ({ code, hotel_id, hotel_code }) => {
  try {
    localStorage.setItem(PENDING_KEY, JSON.stringify({
      code, hotel_id, hotel_code, expiry: Date.now() + PENDING_TTL,
    }));
  } catch (e) { /* โหมดไม่ระบุตัวตน -- ลูกค้ายังพิมพ์รหัสเองได้ */ }
  notify();
};

/**
 * ส่ง hotelId มาเพื่อเอาเฉพาะรหัสของที่พักนั้น
 * ส่ง undefined (ข้อมูลที่พักยังโหลดไม่เสร็จ) จะได้ null ไม่ใช่รหัสของที่พักไหนก็ได้
 */
export const getPendingPromo = (...args) => {
  const anyHotel = args.length === 0;
  const hotelId = args[0];

  try {
    const raw = localStorage.getItem(PENDING_KEY);
    if (!raw) return null;

    const pending = JSON.parse(raw);
    if (!pending?.code || pending.expiry < Date.now()) {
      localStorage.removeItem(PENDING_KEY);
      return null;
    }

    if (!anyHotel && (!hotelId || pending.hotel_id !== hotelId)) return null;
    return pending;
  } catch (e) {
    return null;
  }
};

/** ส่ง code มาเพื่อล้างเฉพาะเมื่อเป็นรหัสเดียวกัน (เช่นหลังจองสำเร็จด้วยรหัสนั้น) */
export const clearPendingPromo = (code) => {
  try {
    const pending = getPendingPromo();
    if (code && pending?.code !== code) return;
    localStorage.removeItem(PENDING_KEY);
  } catch (e) { /* ไม่เป็นไร */ }
  notify();
};
